module.exports = __webpack_public_path__ + "static/media/ms_acc_opt_70_1x.95d6c3b8.png";